<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item
        v-if="showChangeWay || !noCacheComponent"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')"
        title="切换项设置"
        name="1"
      >
        <div class="setting-item" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')">
          <div v-show="showBgSetDialog" ref="tabsBgWrap">
            <tabs-img-upload-dialog
              v-if="tabsItem"
              :tabsItem="tabsItem"
              :tabsActiveIndex="tabsActiveIndex"
              @addImg="closeBgSetDialog"
            ></tabs-img-upload-dialog>
          </div>
          <!-- 自由布局中有数据时控制tab数量 -->
          <el-checkbox class="mb12" v-show="noCacheComponent && showChangeWay" v-model="isCustomTabsNum"
            >自定义标签数量</el-checkbox
          >
          <!-- 标签布局中或者标签没有绑定数据时使用 -->
          <div
            class="verticallyCenter el-input mb12"
            v-show="(!isLoginEngineTab && !noCacheComponent) || (noCacheComponent && showChangeWay && isCustomTabsNum)"
          >
            <span class="mr16">标签数量</span>
            <div class="verticallyCenter tab-set">
              <input
                class="el-input__inner"
                type="number"
                @focus="getFocus($event)"
                style="width: 80px; height: 32px; flex: 1"
                min="1"
                max="10"
                v-model="tabLen"
              />
              <div class="btn-wrapper">
                <span
                  :class="tabLen === 1 ? 'disabled num-btn icon-portal-minus' : 'num-btn icon-portal-minus'"
                  @click="changeTabLen(0)"
                ></span>
                <span
                  :class="tabLen === 10 ? 'disabled num-btn icon-portal-plus' : 'num-btn icon-portal-plus'"
                  class="num-btn icon-portal-plus"
                  @click="changeTabLen(1)"
                ></span>
              </div>
            </div>
          </div>
          <div class="verticallyCenter mb12" v-show="showChangeWay">
            <span class="mr16">切换方式</span>
            <div class="font-arrangement-btn height32 flex1">
              <span class="btn-active" :style="getTranslate"></span>
              <span
                v-for="(val, index) in changeWayList"
                :key="index"
                :class="changeWayType == val.label ? 'select' : ''"
                @click="changeWays(val.label)"
                >{{ val.title }}</span
              >
            </div>
          </div>
          <div class="mb12" v-if="showChangeWay && noCacheComponent">
            <span class="">设置选中项</span>
            <div class="tab-check-box mt8">
              <el-radio-group v-model="options.activeIndex">
                <el-radio v-for="(item, index) in options.tabsList" :key="index" :label="index">
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="mb12 drag-box" v-if="!noCacheComponent">
            <span class="">设置选中项</span>
            <el-radio-group class="tab-check-box mt8" v-model="options.activeIndex">
              <draggable
                element="ul"
                v-model="options.tabsList"
                handle=".mover"
                ghost-class="ghost"
                chosen-class="chosen"
                @start="startDrag"
                @end="endDrag"
                filter=".disabled"
              >
                <li
                  class="menu-item verticallyCenter"
                  v-for="(item, index) in options.tabsList"
                  :key="index"
                  v-show="!item.isHide"
                >
                  <i class="mover icondrag icon-portal-drag" :class="dragging ? 'dragging' : ''"></i>
                  <el-radio :label="index" class="text verticallyCenter" :class="showEditIndex === index ? 'witdhAudo' : ''">
                    <span class="">{{ showEditIndex === index ? "" : item.name }}</span>
                  </el-radio>
                  <div class="edit-box" v-if="showEditIndex === index">
                    <input type="text" v-model="item.name" ref="editInput" />
                    <i class="icon-check" @click.stop="handleClose()"></i>
                    <i class="icon-portal-close-small" @click.stop="handleClose()"></i>
                  </div>
                  <div class="btn-box" v-if="showEditIndex !== index">
                    <el-tooltip class="item" effect="dark" content="编辑" placement="top" :open-delay="1000"
                      ><span class="icon-portal-edit-1" @click.stop="handleCommand(item, index)"></span
                    ></el-tooltip>
                    <el-tooltip
                      v-if="options.tabsList.length > 1 && !isLoginEngineTab"
                      class="item"
                      effect="dark"
                      content="删除"
                      placement="top"
                      :open-delay="1000"
                      ><span class="icon-portal-delete1" @click.stop="handleDel(index)"></span
                    ></el-tooltip>
                  </div>
                </li>
                <div v-if="!options.tabsList" class="null-box">暂无内容</div>
              </draggable>
            </el-radio-group>
          </div>
          <div class="" v-if="!isLoginEngineTab">
            <cx-check-box :value.sync="tabAutoChange" :themeKey="request_prefix" class="mt8"
              >标签页自动切换</cx-check-box
            >
            <div class="data-item mt16" v-if="tabAutoChange">
              <p class="font14 mb8">动画间隔时间</p>
              <slider-and-input :value.sync="autoChangeTime" :sliderMin="1" :sliderMax="300" suffix="秒" />
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="isShowSyncSet && !isLoginEngineTab && enableSyncSetting"
        @mousedown.native="
          $event => {
            collapseMouseDown(collapseActiveNames, $event, '2')
            collapseMouseDownOther($event, '2')
          }
        "
        title="数据同步"
        name="2"
      >
        <div class="setting-item" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')">
          <div class="setting-item syncCol_flex">
            请选择需要被同步的选项卡对应的内容<span @click="syncTab" class="syncCol_btn">同步</span>
          </div>
          <div class="setting-item syncCol_content">
            <el-checkbox
              v-model="getAllTabsIsCheckedAll"
              :indeterminate="allTabsIsCheckedAll"
              class="ml8"
              @change="checkAllTabsHandle"
            ></el-checkbox
            ><label>全部</label>
            <li v-for="(item, index) in allTabs" class="col_li" :key="index">
              <el-checkbox v-model="item.isChecked" @change="changeTabsCheckedHandle($event, index)"></el-checkbox>
              <!--              <label>tab{{ index }}</label>-->
              <label> {{ item.name }}</label>
            </li>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import { primaryBigScreenPageLayoutGenerator as primarybigScreenPageLayoutGenerator } from "store/modules/bigScreen/state"
import { primaryStagePageLayoutGenerator as primarystagePageLayoutGenerator } from "store/modules/stage/state"
import { primaryappStagePageLayoutGenerator as primaryappStagePageLayoutGenerator } from "store/modules/appStage/state"
import { deepChangeAnimateUid } from "utils/event/animate"
import draggable from "vuedraggable"
import tabsImgUploadDialog from "./tabsImgUploadDialog.vue"
import { recordOldSize } from "utils"
import { isExist, simpleDeepClone } from "../../../utils"
import { deepCloneAndFreeze } from "utils/revork"
import { handleChildAppid } from "@/utils/reCreatAppid"
import { CATEGORY_MODE } from "@/consts"

const mockData = {
  primarybigScreenPageLayoutGenerator,
  primarystagePageLayoutGenerator,
  primaryappStagePageLayoutGenerator
}
export default {
  name: "tabs-options-data",
  props: { options: Object },
  components: {
    draggable,
    tabsImgUploadDialog
  },
  data() {
    return {
      activeNames: ["1", "2"],
      collapseActiveNames: ["1", "2"],
      changeWayList: [
        {
          label: 0,
          title: "点击"
        },
        {
          label: 1,
          title: "悬浮"
        }
      ],
      translate: 0,
      allTabs: [],
      getAllTabsIsCheckedAll: false,
      allTabsIsCheckedAll: false,
      tabCheckValue: 0,
      dragging: false,
      showEditIndex: null,
      delCurIndex: undefined,
      showBgSetDialog: false,
      tabsActiveIndex: 0,
      tabsItem: null,
      pageLayoutIndex: null
    }
  },
  created() {
    console.log(this.options, this)
  },
  mounted() {
    document.getElementById("app").addEventListener("click", this.hidder, true)
  },
  beforeDestroy() {
    document.getElementById("app").removeEventListener("click", this.hidder, true)
  },
  watch: {
    "options.activeIndex": {
      deep: true,
      handler(n, o) {
        if (!!n && n != o) {
          const param = {
            ...this.ids,
            option_name: "value",
            option_val: this.options.tabsList[n].name
          }
          this.$store.dispatch(this.request_prefix + "/changeOptions", param)
          setTimeout(() => {
            this.$store.dispatch(this.request_prefix + "/changeTabsActiveIndex", {
              container_id: this.ids.container_id,
              rect_id: this.ids.rect_id,
              directionIndex: this.ids.directionIndex,
              elementInLayoutId: this.ids.elementInLayoutId,
              activeIndex: n,
              uid: this.ids.uid,
              singleTabs: this.options.singleTabs || false,
              isPageLayoutTabs: this.options.isPageLayoutTabs || false,
              elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
              parentRectId: this.options.parentRectId,
              path: this.ids.path
            })
          }, 10)
        }
      }
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    noCacheComponent() {
      let rect = this.getAttrById(
        this.$store.state[this.request_prefix],
        {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id
        },
        "rect"
      )
      return rect.options.noCacheComponent
    },
    getTranslate() {
      return {
        transform: `translateX(${this.translate}px)`
      }
    },
    changeWayType: {
      get() {
        let index = this.changeWayList.findIndex(item => item.label === this.options.changeWayType)
        this.translate = 75.5 * index < 0 ? 0 : 75.5 * index
        return this.options.hasOwnProperty("changeWayType") ? this.options.changeWayType : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "changeWayType", false)
      }
    },
    singleTabs() {
      return this.options.hasOwnProperty("singleTabs") ? this.options.singleTabs : false
    },
    // 判断当前tab是否是放到通栏中使用
    isPageLayoutTabs() {
      return this.options.hasOwnProperty("isPageLayoutTabs") ? this.options.isPageLayoutTabs : false
    },
    // 判断当前tab是否是放到通栏中使用 并且是竖向通栏
    isPageLayoutVerticalTabs() {
      return this.options.hasOwnProperty("isPageLayoutVerticalTabs") ? this.options.isPageLayoutVerticalTabs : false
    },
    tabLen: {
      get() {
        return this.options.hasOwnProperty("tabsList") ? this.options.tabsList.length : 0
      },
      set(newVal) {
        if (this.request_prefix !== "bigScreen") {
          let activeCell = document.getElementsByClassName("active-layout-cell-container")[0]
          let activeLayoutIndex = activeCell.getAttribute("layoutindex")
          let curPageIndex = activeLayoutIndex.split("_")[0]
          this.pageLayoutIndex = curPageIndex
          this.before = this.getQuickShot()
        }
        if (this.isPageLayoutTabs) {
          let activeCell = document.getElementsByClassName("active-layout-cell-container")[0]
          let activeLayoutIndex = activeCell.getAttribute("layoutindex")
          let curPageIndex = activeLayoutIndex.split("_")[0]
          let curLayoutIndex = activeLayoutIndex.split("_")[1] // 当前标签布局所在的布局
          let tempPageLayout = this.getAttrById(
            this.$store.state[this.request_prefix],
            {
              container_id: this.ids.container_id,
              rect_id: this.options.parentRectId,
              pageLayoutId: curPageIndex
            },
            "pageLayout"
          )
          let layout = new mockData["primary" + this.request_prefix + "PageLayoutGenerator"](1)
          layout = simpleDeepClone(layout.layout.rows[0])
          let oldLen = this.options.tabsList.length
          let rowsIndex = activeLayoutIndex?.split("_")[2] // 标签组件所在根布局的上一级布局
          let colsIndex = 1 // 和标签组件平级的布局
          if (this.isPageLayoutVerticalTabs) {
            // 竖向布局
            if (activeLayoutIndex?.split("_")[3] === "1") {
              colsIndex = 0
            }
          } else {
            if (activeLayoutIndex?.split("_")[2] === "1") {
              colsIndex = 0
            }
          }
          let box
          if (isExist(this.options.parentRectId)) {
            box = this.isPageLayoutVerticalTabs
              ? tempPageLayout.layout.rows[rowsIndex].layout.cols[colsIndex].layout.cols
              : tempPageLayout.layout.rows[colsIndex].layout.rows
          } else {
            box = this.isPageLayoutVerticalTabs
              ? tempPageLayout.layout.rows[curLayoutIndex].layout.rows[rowsIndex].layout.cols[colsIndex].layout.cols
              : tempPageLayout.layout.rows[curLayoutIndex].layout.rows[colsIndex].layout.rows
          }
          let curIndex = this.delCurIndex ? this.delCurIndex : box.length - 1
          if(!box[curIndex] && newVal < oldLen){
            // tab 数量和box 数量不一样, 则不删除box
            // 添加tab
            const params = {
              container_id: this.ids.container_id,
              rect_id: this.ids.rect_id,
              elementInLayoutId: this.ids.elementInLayoutId,
              directionIndex: this.ids.directionIndex,
              tabLength: newVal,
              curIndex: this.delCurIndex
            }
            this.$store.dispatch(this.request_prefix + "/changePageLayoutTabslength", params)
            return
          }
          let newId = box[curIndex].id+1
          let height = box[curIndex].options.height
          if (newVal > oldLen) {
            // 添加通栏 行row
            for (let i = 0; i < newVal - oldLen; i++) {
              let newLayout = simpleDeepClone(layout)
              newLayout.id = newId+i
              newLayout.options.height = height
              this.isPageLayoutVerticalTabs ? (newLayout.options.tabCol = true) : (newLayout.options.tabRow = true) // tab可切换行列标志
              box.splice(curIndex + 1, 0, newLayout)
            }
          } else if (newVal < oldLen) {
            // 减少通栏行 row
            for (let i = 0; i < oldLen - newVal; i++) {
              box.splice(curIndex, 1)
            }
          }
          // 添加tab
          const params = {
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id,
            elementInLayoutId: this.ids.elementInLayoutId,
            directionIndex: this.ids.directionIndex,
            tabLength: newVal,
            curIndex: this.delCurIndex
          }
          this.$store.dispatch(this.request_prefix + "/changePageLayoutTabslength", params)
        } else if (!this.singleTabs) {
          const params = {
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id,
            elementInLayoutId: this.ids.elementInLayoutId,
            directionIndex: this.ids.directionIndex,
            maxLength: newVal,
            curIndex: this.delCurIndex
          }
          this.$store.dispatch(this.request_prefix + "/changeLayoutTabsLength", params)
          if(this.request_prefix === "bigScreen"){
            // 为了实现：在大屏中，自由布局标签数据变化时，图层数据同步更新
            this.$store.commit("states/changeIsUpdateLayerDataFlag", true)
          }
        }
        if (this.request_prefix !== "bigScreen") {
          this.addHistory()
        }
      }
    },
    showChangeWay() {
      return this.options?.pluginName?.includes("showTabsChangeWay")
    },
    isShowSyncSet() {
      return this.options.isNoSyncData ? false : true
    },
    tabAutoChange: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "tabAutoChange", "tabAutoChange", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "tabAutoChange", false)
      }
    },
    autoChangeTime: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "autoChangeTime", "autoChangeTime", 10)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "autoChangeTime", false)
      }
    },
    isCustomTabsNum: {
      get() {
        return this.options.hasOwnProperty("isCustomTabsNum") ? this.options.isCustomTabsNum : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isCustomTabsNum", false)
      }
    },
    parentRectAttr() {
      let parentRectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids, "rect")
      if (isExist(this.ids.elementInAutoLayoutId)) {
        parentRectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
      }
      parentRectAttr = parentRectAttr.options ? parentRectAttr.options : parentRectAttr
      return parentRectAttr
    },
    isLoginEngineTab() {
      if (
        this.parentRectAttr &&
        this.parentRectAttr.pluginName &&
        this.parentRectAttr.pluginName[0] == "loginEngineComponentPlugin"
      ) {
        return true
      } else {
        return false
      }
    },
    isAccordionComponent() {
      if (
        this.parentRectAttr &&
        this.parentRectAttr.pluginName &&
        this.parentRectAttr.pluginName[0] == "accordionComponentPlugin"
      ) {
        return true
      } else {
        return false
      }
    },
    enableSyncSetting() {
      let parentRectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids, "rect")
      return parentRectAttr?.options?.categoryMode !== CATEGORY_MODE.SAME
    }
  },
  methods: {
    changeWays(val) {
      this.changeWayType = val
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    changeTabLen(flag) {
      this.delCurIndex = undefined
      if (this.tabLen === 1 && flag === 0) {
        return
      }
      if (this.tabLen === 10 && flag === 1) {
        return
      }
      this.tabLen = flag === 0 ? this.tabLen - 1 : this.tabLen + 1
    },
    collapseMouseDownOther($event, val) {
      if (val === "2" && this.allTabs.length === 0) {
        this.getAllTabs()
      }
    },
    // 获取当前tab组件的的所有选项卡
    getAllTabs() {
      let syncTabIndexList = [] // 除去当前选中的tab的所有tab的index集合
      let rectAttr = this.getRectAttribute.call(this, this.ids).options
      if (this.ids.elementInAutoLayoutId !== undefined) {
        rectAttr = this.getAttrById(
          this.$store.state[this.request_prefix],
          this.ids,
          "elementInAutoLayout"
        )
      }
      for (let i = 0; i < rectAttr.rows.length; i++) {
        if (i !== rectAttr.activeIndex) {
          const obj = {
            index: i,
            name: this.options.tabsList[i].name,
            isChecked: false
          }
          syncTabIndexList.push(obj)
        }
      }
      this.allTabs = syncTabIndexList
    },
    // 同步当前选中tab对应的col
    syncTab() {
      if (this.request_prefix !== "bigScreen") {
        let activeCell = document.getElementsByClassName("active-layout-cell-container")[0]
        let activeLayoutIndex = activeCell.getAttribute("layoutindex")
        let curPageIndex = activeLayoutIndex.split("_")[0]
        this.pageLayoutIndex = curPageIndex
        this.before = this.getQuickShot()
      }
      let rectAttr = this.getRectAttribute.call(this, this.ids).options
      if (this.ids.elementInAutoLayoutId !== undefined) {
        rectAttr = this.getAttrById(
          this.$store.state[this.request_prefix],
          this.ids,
          "elementInAutoLayout"
        )
      }
      const contentMap = {}
      const copyTabIds = []
      const tabsList = this.options.tabsList
      for (let i = 0; i < this.allTabs.length; i++) {
        if (this.allTabs[i].isChecked) {
          const useActiveIndex = rectAttr.categoryMode === CATEGORY_MODE.SAME ? 0 : rectAttr.activeIndex
          const result = {
            ...this.ids,
            content: simpleDeepClone([rectAttr.rows[useActiveIndex]])[0],
            index: this.allTabs[i].index
          }
          const uidMap = deepChangeAnimateUid(result.content)
          contentMap[result.index] = result.content
          let { renderOrder } = rectAttr
          // 旧数据格式不同的清除重做
          if (!renderOrder || Array.isArray(renderOrder)) {
            renderOrder = {}
          }
          const originalOrder = renderOrder[rectAttr.activeIndex]
          if(originalOrder) {
            const newOrder = originalOrder.map(item => uidMap[item])
            renderOrder[this.allTabs[i].index] = newOrder
          }
          this.$changeOptionsEV(
            renderOrder,
            "renderOrder",
            null,
            false,
            {
              container_id: this.ids.container_id,
              rect_id: this.ids.rect_id,
              path:this.ids.path,
              elementInAutoLayoutId: this.ids.elementInAutoLayoutId
            },
            true
          )
          this.$store.dispatch(this.request_prefix + "/changeTabMapRowContent", result)
          // 处理tab同步数据时，处理自由布局内组件带appid的情况（重新生成）
          handleChildAppid.call(this,result,this.ids.container_id,{
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id,
            path:this.ids.path,
            elementInAutoLayoutId: this.ids.elementInAutoLayoutId
          })
          const tab = tabsList.find(item => item.name === this.allTabs[i].name)
          copyTabIds.push(tab.id)
        }
      }
      if (copyTabIds.length > 0) {
        recordOldSize.call(this, rectAttr, {
          target: tabsList[rectAttr.activeIndex].id,
          copy: copyTabIds
        })
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "同步成功!",
          type: "success"
        })
      }
      if (this.request_prefix !== "bigScreen") {
        this.addHistory()
      }
    },
    // 选中所有tab
    checkAllTabsHandle($event) {
      this.allTabsIsCheckedAll = false // 去掉部分选中状态
      this.allTabs.map(item => (item.isChecked = $event))
    },
    // 选中当前tab
    changeTabsCheckedHandle(val, index) {
      let checkedTabs = 0
      this.allTabs[index].isChecked = val
      this.allTabs.map(item => {
        if (item.isChecked) {
          checkedTabs++
        }
      })
      if (checkedTabs === 0) {
        this.allTabsIsCheckedAll = false
        this.getAllTabsIsCheckedAll = false
      } else {
        if (checkedTabs !== this.allTabs.length) {
          this.allTabsIsCheckedAll = true
        } else {
          this.allTabsIsCheckedAll = false
          this.getAllTabsIsCheckedAll = true
        }
      }
    },
    startDrag(e) {
      this.dragging = true
    },
    endDrag(e) {
      this.dragging = false
      this.$store.dispatch(this.request_prefix + "/changeTabsOrder", {
        ...this.ids,
        parentRectId: this.options.parentRectId,
        isPageLayoutTabs: this.options.isPageLayoutTabs || false,
        oldIndex: e.oldIndex,
        newIndex: e.newIndex
      })
      if (this.isLoginEngineTab) {
        const param = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          path:this.ids.path,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          option_name: "tabsList",
          option_val: this.options.tabsList
        }
        this.$store.dispatch(this.request_prefix + "/changeOptions", param)
      }
    },
    handleCommand(item, index) {
      this.showBgSetDialog = true
      this.tabsActiveIndex = index
      this.tabsItem = simpleDeepClone(this.options.tabsList[index])
    },
    handleDel(index) {
      this.delCurIndex = index
      this.tabLen = this.tabLen - 1
    },
    handleClose() {
      this.showEditIndex = null
    },
    closeBgSetDialog() {
      this.showBgSetDialog = false
    },
    hidder(e) {
      let ele = this.$refs.tabsBgWrap?.querySelector(".bg-set-dialog")
      if (ele && ele.contains(e.target)) {
        return
      } else {
        this.showBgSetDialog = false
      }
    },
    // 获取当前快照
    getQuickShot() {
      const { container_id, rect_id } = this.ids
      const page = this.$store.state[this.request_prefix].page
      const rect = page.children[0].children.find(rect => rect.rect_id === rect_id)
      const pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
      const pageLayout = pageLayoutList[this.pageLayoutIndex]
      const data = {
        rect,
        pageLayout
      }
      return deepCloneAndFreeze(data)
    },
    // 记录状态
    addHistory() {
      const newData = this.getQuickShot()
      const pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
      this.$addHistory({
        type: "update",
        stateType: "updateTabRect",
        payload: {
          container_id: this.ids.container_id,
          pageLayoutId: pageLayoutList[this.pageLayoutIndex].id,
          rect_id: this.ids.rect_id
        },
        before: this.before,
        data: newData
      })
      this.before = null
    }
  }
}
</script>
<style lang="scss">
.font-arrangement-btn {
  height: 32px;
}
.font-arrangement-btn .btn-active {
  width: calc((100% - 6px) / 2);
}
.font-arrangement-btn.height32 span {
  font-size: 18px;
  height: 26px;
  font-size: 13px;
  line-height: 26px;
}
.tab-set {
  flex: 1;
  input {
    background-color: var(--inputBg);
    border-radius: 4px;
    padding: 0 10px;
    box-sizing: border-box;
    margin-right: 8px;
  }
  .btn-wrapper {
    flex: 1;
    background-color: var(--inputBg);
    border-radius: 4px;
    padding: 6px 0;
    font-size: 0;
    .num-btn {
      display: inline-block;
      width: 50%;
      text-align: center;
      line-height: 20px;
      font-size: 18px;
      cursor: pointer;
      color: var(--subTextColor);
      &:not(:last-child) {
        border-right: 1px solid var(--sliderBackGround);
      }
      &:not(.disabled):hover {
        color: var(--themeColor);
      }
      &.disabled {
        color: var(--borderColorSeven);
        cursor: not-allowed;
      }
    }
  }
}
.col_li {
  padding-left: 8px;
}
.col_li:hover {
  background: var(--themeColorSelectBg);
}
.syncCol_flex {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.syncCol_btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 80px;
  height: 28px;
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
}
.syncCol_content {
  background: var(--inputArrowBgColor);
  border: 1px solid var(--messageTipsBorderColor);
  border-radius: 4px;
  padding: 8px 4px;
}
.tab-check-box {
  background: var(--inputArrowBgColor);
  border: 1px solid var(--messageTipsBorderColor);
  border-radius: 4px;
  padding: 12px;
  display: block;
  .el-radio-group {
    .el-radio {
      display: block;
      margin-top: 12px;
      margin-bottom: 0;
      white-space: pre-wrap;
      width: 100%;
      &:first-child {
        margin-top: 0;
      }
    }
  }
  .menu-item {
    position: relative;
    min-height: 32px;
    border-radius: 4px;
    margin-top: 8px;
    font-size: 14px;
    &:first-child {
      margin-top: 0;
    }
    .icondrag {
      color: var(--fourthTextColor);
      margin-right: 6px;
      font-size: 16px;
      &:not(.disabled):hover {
        color: var(--themeColor);
        cursor: grab;
      }
      &.dragging {
        cursor: grabbing;
      }
      &.disabled {
        cursor: not-allowed;
      }
    }
    .img {
      width: 20px;
      height: 20px;
      border: 1px solid #dee0e3;
      border-radius: 4px;
      overflow: hidden;
      margin-right: 4px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        vertical-align: top;
      }
    }
    .text {
      width: calc(100% - 80px);
      &.witdhAudo {
        width: auto;
      }
      .el-radio__label {
        display: inline-block;
        width: calc((100% - 10px));
        span {
          display: block;
          width: 100%;
          white-space: break-spaces;
        }
      }
    }
    .btn-box {
      position: absolute;
      right: 0;
      span {
        display: inline-block;
        vertical-align: top;
        width: 24px;
        height: 24px;
        border-radius: 4px;
        text-align: center;
        line-height: 24px;
        color: var(--subTextColor);
        cursor: pointer;
        margin-left: 4px;
        &:hover {
          background: rgba(31, 35, 41, 0.08);
        }
      }
    }
    .edit-box {
      display: inline-block;
      input {
        box-shadow: inset 0px 0px 0px 2px var(--themeColor);
        border-radius: 4px;
        background: transparent;
        width: 106px;
        height: 28px;
        padding: 5px 8px;
      }
      i {
        line-height: 28px;
        display: inline-block;
        vertical-align: top;
        color: var(--themeColor);
        font-size: 20px;
        margin-left: 6px;
        cursor: pointer;
      }
    }
  }
}
.drag-box {
  .tab-check-box {
    &.el-radio-group {
      .el-radio {
        margin-right: 0;
      }
    }
  }
}
</style>
